export enum ModelApiKey {
  Index = 'index',
  Page = 'page',
  Article = 'article',
  ProgramProduct = 'program_product',
  ShopProduct = 'shop_product',
  ShopCategory = 'shop_category'
}
